import { BrowserRouter } from "react-router-dom";
import { RoutesWeb } from "./routes";

import { AuthProvider } from "./context/AuthContext";
import { NotificationProvider, ThemeProvider } from "./context";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <NotificationProvider>
          <BrowserRouter>
            <RoutesWeb></RoutesWeb>
          </BrowserRouter>
        </NotificationProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
